import React from "react";
import localeText from "../../../locale";

const ConfimeaHowItWorks = () => {
  const steps = [
    {
      number: 1,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      ),
      titleKey: "step1Title",
      textKey: "step1Text",
      linkKey: "step1Link",
    },
    {
      number: 2,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <path d="M22 4L12 14.01l-3-3" />
        </svg>
      ),
      titleKey: "step2Title",
      textKey: "step2Text",
      linkKey: "step2Link",
    },
    {
      number: 3,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
        </svg>
      ),
      titleKey: "step3Title",
      textKey: "step3Text",
      linkKey: "step3Link",
    },
  ];

  return (
    <section id="how-it-works" className="confimea-section confimea-steps-section hidden md:block">
      <div className="confimea-container">
        <div className="confimea-section-header flex flex-column gap-4">
          <div>
            <span className="confimea-section-badge">{localeText("howItWorksBadge")}</span>
          </div>

          <div className="confimea-section-title">{localeText("howItWorksTitle")}</div>
          <div className="confimea-section-subtitle">{localeText("howItWorksSubtitle")}</div>
        </div>

        <div className="confimea-steps-grid">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="confimea-step">
                <div className="confimea-step-number">{step.number}</div>
                <div className="confimea-step-card pt-7">
                  <div className="confimea-step-icon">{step.icon}</div>
                  <div className="confimea-step-title">{localeText(step.titleKey)}</div>
                  <div className="confimea-step-text">{localeText(step.textKey)}</div>

                  <div className="confimea-step-badge flex align-items-center gap-2">
                    <i className="pi pi-clock" style={{ fontSize: "0.875rem" }}></i>
                    {localeText(step.linkKey)}
                  </div>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="confimea-step-arrow">
                  <i className="pi pi-arrow-right"></i>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConfimeaHowItWorks;
